import { useParams } from 'react-router-dom';
import { useGetDynamicRulesLogsQuery } from '@/services/dslApi';
import { useGetAssetByIdQuery } from '@/services';
import AuditHistory from '@/components/AuditHistory';

export default function DynamicRulesHistory() {
    const { assetId, id: amcId } = useParams<{ assetId: string; id: string }>();
    const { data: asset } = useGetAssetByIdQuery(assetId!, { skip: !assetId });
    const { data, isLoading, error } = useGetDynamicRulesLogsQuery(assetId!, { skip: !assetId });

    return (
        <AuditHistory
            title="Dynamic Rules History"
            entityName={asset?.name}
            backLink={amcId ? {
                to: `/amcs/${amcId}/assets/${assetId}/try-dynamic-routing`,
                label: 'Back to Dynamic Rules'
            } : undefined}
            data={data}
            isLoading={isLoading}
            error={error}
            emptyMessage="No dynamic rules history found."
        />
    );
}
